const getters = {
  device: state => state.app.device,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state =>  state.session.user&&state.session.user.avatar?state.session.user.avatar:'/avatar2.jpg',
  nickname: state => state.session.user&&state.session.user.name?state.session.user.name:'',
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  tenant:state=>state.session.tenant,
  application:state=>state.session.application,
  user:state=>state.session.user,
  abp:()=>window.abp,
  permissions:()=>window.abp.auth.grantedPermissions,
  initRouters:state=>state.permission.initRouters
}

export default getters